import Homedecoration from "../../images/homeliving/home_decoration.jpg";
import hometapistre from "../../images/homeliving/home_tapistre.jpg";
import hometextile from "../../images/homeliving/home_textile.jpg";
import homewoven from "../../images/homeliving/home_woven.jpg";

const KidsProducts = [
  {
    image: Homedecoration,
    name: "Home decoration",
    price: "$12.00 USD",
  },
  {
    image: hometapistre,
    name: "Home tapistre",
    price: "$14.00 USD",
  },
  {
    image: hometextile,
    name: "Home textile",
    price: "$5.99 USD",
  },
  {
    image: homewoven,
    name: "Home woven",
    price: "$5.99 USD",
  },
];

export default KidsProducts;
